import React, { useState, useEffect } from 'react';
import {
  Paper,
  Typography,
  Box,
  TextField,
  Button,
  Grid,
  Switch,
  FormControlLabel,
  Alert,
  Divider,
} from '@mui/material';
import { db } from '../../firebase/config';
import {
  doc,
  getDoc,
  updateDoc,
  setDoc,
} from 'firebase/firestore';

const Settings = () => {
  const [settings, setSettings] = useState({
    schoolName: '',
    academicYear: '',
    enableNotifications: true,
    enableMessaging: true,
    maxAbsenceDays: 30,
    maxLeaveRequests: 5,
    emailNotifications: true,
    autoApproveLeave: false,
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const settingsDoc = await getDoc(doc(db, 'settings', 'global'));
      if (settingsDoc.exists()) {
        setSettings(settingsDoc.data());
      }
      setLoading(false);
    } catch (error) {
      setError('Erreur lors du chargement des paramètres');
      setLoading(false);
    }
  };

  const handleChange = (event) => {
    const { name, value, checked } = event.target;
    setSettings(prev => ({
      ...prev,
      [name]: event.target.type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    try {
      await setDoc(doc(db, 'settings', 'global'), settings);
      setSuccess('Paramètres mis à jour avec succès');
    } catch (error) {
      setError('Erreur lors de la mise à jour des paramètres');
    }
  };

  if (loading) {
    return <Typography>Chargement...</Typography>;
  }

  return (
    <Paper sx={{ p: 3 }}>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}

      <form onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          {/* Paramètres généraux */}
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              Paramètres généraux
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Nom de l'école"
                  name="schoolName"
                  value={settings.schoolName}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Année académique"
                  name="academicYear"
                  value={settings.academicYear}
                  onChange={handleChange}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Paramètres des congés */}
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              Paramètres des congés
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  type="number"
                  label="Nombre maximum de jours d'absence"
                  name="maxAbsenceDays"
                  value={settings.maxAbsenceDays}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  type="number"
                  label="Nombre maximum de demandes de congés"
                  name="maxLeaveRequests"
                  value={settings.maxLeaveRequests}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={settings.autoApproveLeave}
                      onChange={handleChange}
                      name="autoApproveLeave"
                    />
                  }
                  label="Approbation automatique des congés"
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Paramètres des notifications */}
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              Paramètres des notifications
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={settings.enableNotifications}
                      onChange={handleChange}
                      name="enableNotifications"
                    />
                  }
                  label="Activer les notifications"
                />
              </Grid>
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={settings.emailNotifications}
                      onChange={handleChange}
                      name="emailNotifications"
                    />
                  }
                  label="Activer les notifications par email"
                />
              </Grid>
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={settings.enableMessaging}
                      onChange={handleChange}
                      name="enableMessaging"
                    />
                  }
                  label="Activer la messagerie interne"
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Bouton de soumission */}
          <Grid item xs={12}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size="large"
              >
                Enregistrer les paramètres
              </Button>
            </Box>
          </Grid>
        </Grid>
      </form>
    </Paper>
  );
};

export default Settings;
